'use client';

import { Context, createContext, useCallback, useMemo, useState } from 'react';

export interface GlobalState {
  currentStep?: number;
  totalSteps?: number;
  adminSelectedLink?: string;
  parameters?: {
    feeValue?: number;
    [key: string]: any;
  };
  [key: string]: any;
}

export interface GlobalContextValue {
  state: GlobalState;
  getState: <T = any>(name: string) => T;
  setState: (name: string, value: any) => void;
}

const GlobalContext: Context<GlobalContextValue> = createContext({} as GlobalContextValue);

export const GlobalProvider = ({
  children,
  initialState,
}: {
  children: React.ReactNode;
  initialState: GlobalState;
}) => {
  const [state, setGlobalState] = useState<GlobalState>(initialState);

  const setState = useCallback((name: string, value: any) => {
    setGlobalState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }, []);

  const getState = useCallback(
    <T = any,>(name: string): T => {
      return state[name] as T;
    },
    [state]
  );

  const contextValue = useMemo<GlobalContextValue>(
    () => ({
      state,
      getState,
      setState,
    }),
    [state, getState, setState]
  );

  return <GlobalContext.Provider value={contextValue}>{children}</GlobalContext.Provider>;
};

export default GlobalContext;
